import { useObservableState } from 'observable-hooks';
import defaultState from './default';
import facade from './facade';
import { type UIState } from './store';
import { type FacadeReturnTypes, type NullablePartial } from 'utils/modules/state';

type DefaultState = typeof defaultState;

interface GlobalUIFacade extends FacadeReturnTypes<typeof facade>, DefaultState {
   error: any;
   isLoading: boolean;
}

const defaults: NullablePartial<GlobalUIFacade> = {
   isLoading: true,
   ...defaultState,
};

export default function useUIState() {
   return {
      state: new Proxy<GlobalUIFacade>({} as GlobalUIFacade, {
         get: (target, prop: keyof GlobalUIFacade) => {
            if (prop === 'error') {
               // eslint-disable-next-line react-hooks/rules-of-hooks
               return useObservableState(facade.query.selectError());
            }
            if (prop === 'isLoading') {
               // eslint-disable-next-line react-hooks/rules-of-hooks
               return useObservableState(facade.loading$, defaults[prop]);
            }

            // eslint-disable-next-line react-hooks/rules-of-hooks
            return useObservableState(
               facade.query.select((state) => state[prop as keyof UIState]),
               defaults[prop]
            );
         },
      }),

      query: facade.query,
      updateUIState: facade.updateUIState,
      toggleUIState: facade.toggleUIState,
      batchUpdateUI: facade.batchUpdateUI,
   };
}
